import { useTranslation } from "react-i18next";

const ProductionLogistics = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className="font-semibold text-[32px] text-center pb-10 ">
            {t("productionLogistics")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("howCachingApplies")}
          </h2>
          <p className="my-4 text-lg">{t("productionLogisticsRefers")}</p>
          <section className="space-y-4">
            <p>
              <span className="text-mainBlue">{t("materialHandling")}</span>
              {t("processOfTransporting")}
            </p>
            <p>
              <span className="text-mainBlue">{t("inventoryManagement")}</span>
              {t("ensuringSufficientSupply")}
            </p>
            <p>
              <span className="text-mainBlue">{t("productionScheduling")}</span>
              {t("organizingProduction")}
            </p>
            <p>
              <span className="text-mainBlue">{t("informationFlow")}</span>
              {t("flowOfInfo")}
            </p>
            <p>
              <span className="text-mainBlue">{t("efficiency")}</span>
              {t("streamlinesProcesses")}
            </p>
            <p>
              <span className="text-mainBlue">{t("qualityControl")}</span>
              {t("ensuresTheRightMaterial")}
            </p>
            <p>
              <span className="text-mainBlue">{t("costManagement")}</span>
              {t("optimizingTheFlowOFGoods")}
            </p>
          </section>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/productionLogistics1.jpg"
            alt="production Logistics 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/productionLogistics2.jpg"
            alt="production Logistics 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/productionLogistics3.jpg"
            alt="production Logistics 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/productionLogistics4.jpg"
            alt="production Logistics 4"
          />
        </section>

        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("marketChallenges")}
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="text-mainBlue">{t("1productionLogistics")}</h3>
              <p>{t("productionLogisticsEncompasses")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("2addressingMarketChallenges")}</h3>
              <p>{t("internationalTradePoses")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("3marketChallenges")}</h3>
              <p>{t("severalMarketIssues")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("4megtlogisticsSolutions")}</h3>
              <p>{t("megtlogisticsAddressesChallenges")}</p>
            </div>
            <div>
              <h3 className="text-mainBlue">{t("5TheRoleOfProductionLogistics")}</h3>
              <p>{t("logisticsIsAKey")}</p>
            </div>
          </div>

          {/* Conclusion */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">{t("conclusion")}</h3>
          <p>{t("megtlogisticsProvidesComprehensive")}</p>
        </section>
      </div>
    </main>
  );
};

export default ProductionLogistics;
